import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'reducers';

/**
 * Memoized selector for the CardDetailModal component.
 * Consolidates 12 individual useSelector calls into one, reducing re-renders
 * by only recalculating when the relevant store slices change.
 */
export const selectCardDetailModalContext = createSelector(
  [
    (state: RootState) => state.userStore,
    (state: RootState) => state.cardDetailView,
    (state: RootState) => (state as any).setSingleCardStatus,
    (state: RootState) => (state as any).activateCard,
    (state: RootState) => state.cardsStore,
  ],
  (userStore, cardDetailView, setSingleCardStatus, activateCard, cardsStore) => ({
    canReadWrite: userStore.canReadWriteCards,
    assignedGrandfatherClientNumber: userStore.assignedGrandfatherClientNumber,
    cardDetail: cardDetailView.cardDetail,
    isPreviousOrReplacementCardClicked: cardDetailView.isPreviousOrReplacementCardClicked,
    previousOrReplacementCardNumber: cardDetailView.previousOrReplacementCardNumber,
    isResetSelectedContent: cardDetailView.isResetSelectedContent,
    cardDetailLoading: cardDetailView.isLoading,
    cardDetailError: cardDetailView.isError,
    updateSingleCardStatusSuccess: setSingleCardStatus.success,
    activateCardLoaded: activateCard.activateCardSuccess,
    singleCardTransferLoaded: cardsStore.singleCardTransferLoaded,
  })
);
